import React, { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import { COLORS } from '@ydistri/theme';
import { AppMcpStatus } from '@ydistri/api-sdk';
import { useGetAppMcpStatusQuery } from './apiYbot';
import { McpBadge, McpBadgeDot } from './ybotMcpBadge';

/** How often to re-check while unavailable; stops once available (see the effect below). */
const POLL_WHILE_UNAVAILABLE_MS = 5000;

const MCP_NAME = 'ydistri-app';

/**
 * The application's own MCP, as the API sees it from the inside: green when the API's self-check -
 * a token minted the way a turn gets one, the SDK's client, one ping - passed, red when the
 * endpoint, the token or the tool failed. No login state and no click: whoever is logged into the
 * application is logged into the app MCP, unlike ydistri-devs, which is an external tool with a
 * login of its own.
 */
const AppMcpStatusIcon: React.FC = () => {
  const [pollingInterval, setPollingInterval] = useState(POLL_WHILE_UNAVAILABLE_MS);
  const { currentData: status, isError } = useGetAppMcpStatusQuery(undefined, { pollingInterval });
  const available = !isError && status === AppMcpStatus.Available;

  // A query error is red like any other failure: the endpoint did not answer.
  useEffect(() => {
    setPollingInterval(available ? 0 : POLL_WHILE_UNAVAILABLE_MS);
  }, [available]);

  const color = available ? (COLORS.SUCCESS ?? 'green') : (COLORS.DANGER ?? 'red');
  const label = available ? 'Application MCP: connected' : 'Application MCP: unavailable';

  return (
    <Tooltip title={label}>
      <McpBadge $color={color} role="status" aria-label={label}>
        <McpBadgeDot $color={color} />
        MCP: {MCP_NAME}
      </McpBadge>
    </Tooltip>
  );
};

export default AppMcpStatusIcon;
